import { ChangeDetectionStrategy, Component, computed, inject, input, output, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ENVIRONMENT } from '@iot-platform/core';
import { Environment } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';
import { get } from 'lodash';

@Component({
  imports: [TranslatePipe, MatButtonModule, MatIconModule],
  selector: 'iot-platform-login-select-authentication',
  templateUrl: './login-select-authentication.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./login-select-authentication.component.scss', '../../scss/style.scss']
})
export class LoginSelectAuthenticationComponent {
  private readonly environment: Environment = inject(ENVIRONMENT);
  ssoDisabled = input<boolean>(false);
  signInWithSSO = output<void>();
  signInWithEmailPassword = output<void>();
  carmUrl: Signal<string> = computed(() => get(this.environment, ['carmUrl'], ''));
}
